<ngx-spinner size="medium" color="#fff" type="ball-beat" [fullScreen]="true">
    <p>{{loadingText}}</p>
</ngx-spinner>